export default {
  path: '/signup',
  name: 'signup',
  component: () => import('../views/auth/SignUp.vue'),
  meta: {
    layout: 'empty',
    public: true
  }
}